var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline endereco"},_vm._l((_vm.partes),function(parte,idx){return _c('span',{key:idx,staticClass:"d-inline-block"},[(_vm.linkValido(parte))?_c('a',{attrs:{"href":_vm.enderecoCompleto(parte),"rel":"noopener noreferrer","target":"_blank"}},[_vm._v(_vm._s(parte))]):_c('span',[_vm._v(_vm._s(parte))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }